import React from 'react';

const Creators = () => <section className="Creators">Creators Component</section>;

export default Creators;
